//--
import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';
//#reg
const GetPaymentLogsListCustomerId = (params: any) =>
    request({
        url: ApiURL.Query.GetPaymentLogsListCustomerId + '?customerId=' + params,

        method: RequestType.GET,
        // params:params,
    });
const GetPaymentLogsListOrderNumber = (params: any) =>
    request({
        url: ApiURL.Query.GetPaymentLogsListOrderNumber + '?orderNumber=' + params,

        method: RequestType.GET,
        //params:params,
    });
const GetPaymentMethod = () =>
    request({
        url: ApiURL.Query.GetPaymentMethod,
        method: RequestType.GET,
        //params:params,
    });

const GetCountriesById = (params: any) =>
    request({
        url: `${ApiURL.Query.GetCountriesById}?CountryId=${params}`,
        method: RequestType.GET,
        //  params:params,
    });

const GetCreditCardTypes = (params: any) => {
    let parameters = params != null ? `?CountryId=${params['countryId']}` : '';
    return request({
        url: `${ApiURL.Query.GetCreditCardTypes}${parameters}`,
        method: RequestType.GET,
        //  params:params,
    });
};

const GetCreditCardTypesByCountryId = (params: any) =>
    request({
        url: `${ApiURL.Query.GetCreditCardTypesByCountryId}?CountryId=${params}`,
        method: RequestType.GET,
        //  params:params,
    });

const GetExistInstallments = (params: any) =>
    request({
        url: `${ApiURL.Query.GetExistInstallments}?CountryId=${params['countryId']}&CreditCardTypeId=${params['creditCardTypeId']}`,
        method: RequestType.GET,
        //  params:params,
    });

const GetCreditCardTypePaymentPlans = (params: any) => {
    let parameters = '';

    if (params['countryId'] != undefined) {
        parameters += `CountryId=${params['countryId']}`;
    }

    if (params['creditCardTypeId'] != undefined) {
        parameters += parameters.length > 0 ? '&' : '';
        parameters += `CreditCardTypeId=${params['creditCardTypeId']}`;
    }

    if (params['numberOfInstallment'] != undefined && params['numberOfInstallment'] != null) {
        params['numberOfInstallment'].forEach((item: any, index: number) => {
            parameters += params['numberOfInstallment'].length > index ? '&' : '';
            parameters += `NumberOfInstallments=${item}`;
        });
    }

    if (params['status'] != undefined) {
        parameters += parameters.length > 0 ? '&' : '';
        parameters += `Status=${params['status']}`;
    }

    return request({
        url: `${ApiURL.Query.GetCreditCardTypePaymentPlans}?${parameters}`,
        method: RequestType.GET,
        //  params:params,
    });
};
const GetKKIadePortalData = (params: any) =>
    request({
        url: `${ApiURL.Query.GetKKIadePortalData}?orderNumber=${params}`,
        method: RequestType.GET,
    });

const GetPaymentByOrderId = (params: any) =>
    request({
        url: ApiURL.Query.GetPaymentByOrderId,
        method: RequestType.GET,
        params: params,
    });
const GetPaymentByReturnId = (params: any) =>
    request({
        url: ApiURL.Query.GetPaymentByReturnId,
        method: RequestType.GET,
        params: params,
    });
const GetPaymentForReturn = (params: any) =>
    request({
        url: ApiURL.Query.GetPaymentForReturn,
        method: RequestType.GET,
        params: params,
    });
const GetCustomerPaymentMethodAvailabilityStatus = (params: any) =>
    request({
        url: ApiURL.Query.GetCustomerPaymentMethodAvailabilityStatus,
        method: RequestType.GET,
        params: params,
    });
const GetRefundMoneyBalance = (params: any) =>
    request({
        url: ApiURL.Query.GetRefundMoneyBalance,
        method: RequestType.POST,
        params: params,
    });
const GetWalletTransactionByCustomerId = (params: any) =>
    request({
        url: ApiURL.Query.GetWalletTransactionByCustomerId,
        method: RequestType.GET,
        params: params,
    });

const GetOrderPaymentsAndRefunds = (data: any): Promise<any> =>
    request({
        url: ApiURL.Query.GetOrderPaymentsAndRefunds,
        method: RequestType.POST,
        data,
    });

const PaymentQuery = {
    GetPaymentLogsListCustomerId,
    GetPaymentLogsListOrderNumber,
    GetPaymentMethod,
    GetCountriesById,
    GetCreditCardTypes,
    GetCreditCardTypesByCountryId,
    GetExistInstallments,
    GetCreditCardTypePaymentPlans,
    GetKKIadePortalData,
    GetPaymentByOrderId,
    GetPaymentByReturnId,
    GetPaymentForReturn,
    GetCustomerPaymentMethodAvailabilityStatus,
    GetRefundMoneyBalance,
    GetWalletTransactionByCustomerId,
    GetOrderPaymentsAndRefunds,
};

export default PaymentQuery;
